import React, { useCallback, useEffect, useRef, useState } from 'react';
import AppSettings from '../../../../Settings/AppSettings';
import ServiceWrapper from '../../../../Services/ServiceWrapper';
import AuthManager from '../../../../Common/AuthManager';
import Utils from '../../../../Common/Utils';
import CustomSearchBar from '../components/CustomSearchBar';
import { TParent } from 'types/Pages/ProductDelta';


interface DialogProps {
  onClose: () => void;
  search: string
  setSearch: React.Dispatch<React.SetStateAction<string>>
  categoryid: string,
  handleSubmit: React.MouseEventHandler<HTMLButtonElement>,
  loading: boolean
  setParentId: React.Dispatch<React.SetStateAction<string|null>>
}

const api_base_url = AppSettings.GMS_BACKEND_API_URL;

const MoveToParentDialog = ({ 
  onClose, 
  setSearch, 
  search, 
  categoryid,
  handleSubmit,
  loading,
  setParentId
}: DialogProps) => {
  const [suggestions, setSuggestions] = useState<TParent[]>([])
  const [suggestionOpen, setSuggestionOpen] = useState<boolean>(false)
  const suggestionsRef = useRef<HTMLDivElement>(null)

  const fetchSuggestions = async () => {
    if(!search) setSuggestions([])
    const res = await ServiceWrapper.doGet(
      api_base_url +
      `parents/${categoryid}?search=${search}`,
      null,
      null,
      AuthManager.getGmsToken()
    )
    
    if(res?.data?.done && res?.data?.data) {
      setSuggestions(res?.data?.data ?? [])
    }
    else{
      setSuggestions([])
      setSuggestionOpen(false)
    }
  }

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>, id: string, label: string) =>{
    e.preventDefault()
    setParentId(id)
    setSearch(label)
    setSuggestionOpen(false)
  }

  const handleClickOutside = useCallback(
    (e: MouseEvent) =>
      Utils.run_callback_on_click_outside_ref(e, suggestionsRef, () => setSuggestionOpen(false)),
    [suggestionsRef]
  );

  useEffect(() => {
    // close dropdown if clicked outside
    suggestionOpen
      ? document.addEventListener("mousedown", handleClickOutside)
      : document.removeEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [suggestionsRef, handleClickOutside, suggestionOpen]);

  useEffect(() => {
   fetchSuggestions()
  }, [search])

  return (
    <div className={`tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-scrim`}>
      <div className={`tw-bg-surface tw-rounded tw-shadow-md tw-w-1/4 tw-h-auto`}>
        <h2 className={`tw-text-sm tw-font-semibold tw-my-3 tw-px-3 `}>Move to Parent</h2>
        <div className={`tw-box-border tw-w-auto tw-h-px tw-border-t-[1px] tw-border-solid tw-border-edge`} />  
        <div className={`tw-px-3  tw-my-3 `}>
            <label className={`tw-font-normal tw-w-full tw-text-sm `}>Select Parent</label>
            <div className="tw-relative">
              <CustomSearchBar 
              placeholder='Search parent name'
              handleSearchChange = {(value) => setSearch(value)}
              value={search}
              onFocus={() => setSuggestionOpen(true)}
              autoComplete='off'
              />
              {
                (suggestionOpen) &&
                <div ref = {suggestionsRef} className="tw-flex tw-absolute tw-rounded tw-top-full tw-left-0 tw-w-full tw-bg-surface-raised tw-border tw-z-10 tw-flex-col">
                  {
                    
                    suggestions.slice(0, 5).map((suggestion, key) =>(
                      <button data-testid={`productlist-movetoparentdialog-button-1-${key}`} key={key} onClick = {(e) => handleClick(e, suggestion.uid, suggestion.name)} className="tw-px-2 tw-py-1.5 tw-text-left hover:tw-bg-surface-hover-strong">
                        {suggestion.name}
                      </button>
                    ))
                  }
                </div>
              }
            </div>
        
        
        </div>

        <div className={`tw-px-3 tw-my-4 tw-flex tw-gap-2 tw-justify-end`}>
            <button data-testid="productlist-movetoparentdialog-button-2" onClick={() => onClose()} className='outline-button'>Cancel</button>
            
            <button data-testid="products-move-to-parent-submit-btn" disabled={loading} onClick={handleSubmit} className={`button-style`}>Move</button>
        </div>
      </div>
    </div>
  );
};

export default MoveToParentDialog;
